import { Button, DatePicker, Input, Select } from "antd";
import styled from "styled-components";
const { RangePicker } = DatePicker

export const InputBox = styled(Input)`
    input{
        font-size:14px;
    }
`;
export const SelectBox = styled(Select)`
    font-size:14px;
    div.ant-select-selector{
        border-radius:7px !important;
    }
`;
export const RangePickerBox = styled(RangePicker)`
    font-size:14px;
    border-radius:7px !important;
    height: 40px;
    width: 100%;
    .ant-picker-input {
        input{
            font-size:14px;
        }
    }
`;
export const XButton = styled(Button)`
    font-size:14px;
    border-radius:7px !important;
`;